import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface ExtensionContext {
  SYS02CON: string;
  SYS02EXT: string;
  NAV_ID: string;
  filtrosObligatorios$: Observable<any[]>;
  filtrosOpcionales$:   Observable<any[]>;
  seleccion$:           Observable<any[]>;
  data$:                Observable<any[]>;
  reload$:              Observable<void>;
}

export const EXTENSION_CONTEXT = new InjectionToken<ExtensionContext>('EXTENSION_CONTEXT');

export const ON_SUBMIT_TOKEN = new InjectionToken<(data: any) => void>('onSubmit');